<!--
component: BrowseBuildingIken
author: Ken Nakamura
description: 建築計画概要書（第一面 意見者）
-->
<template>
  <section>
    <div v-show="startIndex==0" class="gaiyo-row">
      <hr>
      <div class="gaiyo-major-title">
      【4.建築設備に関し意見を聴いた者】
      </div>
    </div>
    <div v-show="ikens.length==0" class="person-block">
      <div class="gaiyo-row">
        <div class="gaiyo-person-type">（代表となる建築設備に関し意見を聴いた者）</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ｲ.氏名】</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾛ.勤務先】</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾊ.郵便番号】</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾆ.所在地】</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾎ.電話番号】</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾍ.登録番号】</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾄ.意見を聴いた設計図書】</div>
      </div>
    </div>
    <div v-for="(iken, index) in ikens" :key="index">
      <div v-show="index>=startIndex && index<endIndex" class="person-block">
        <div class="gaiyo-row">
          <div v-show="index==0" class="gaiyo-person-type">（代表となる建築設備に関し意見を聴いた者）</div>
          <div v-show="index==1" class="gaiyo-person-type"><br>（その他の建築設備に関し意見を聴いた者）</div>
        </div>
        <div class="gaiyo-row">
          <div v-show="index>1"><br></div>
          <div class="gaiyo-minor-title">【ｲ.氏名】</div>
          <div class="gaiyo-element left-45">{{iken.ikensyA_NAME}}</div>
          <div v-for="(n,index) in wordwrap(iken.ikensyA_NAME,34)" :key="`iken-name-${index}`">
            <br v-show="index>0"></div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾛ.勤務先】</div>
          <div class="gaiyo-element left-45">{{iken.ikensyA_KINMUSAKI}}</div>
          <div v-for="(n,index) in wordwrap(iken.ikensyA_KINMUSAKI,34)" :key="`iken-kinmu-${index}`">
            <br v-show="index>0"></div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾊ.郵便番号】</div>
          <div class="gaiyo-element left-45">{{iken.ikensyA_POSTNO}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾆ.所在地】</div>
          <div class="gaiyo-element left-45">{{iken.ikensyA_ADDR}}</div>
          <div v-for="(n,index) in wordwrap(iken.ikensyA_ADDR,34)" :key="`iken-addr-${index}`">
            <br v-show="index>0"></div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾎ.電話番号】</div>
          <div class="gaiyo-element left-45">{{iken.ikensyA_TELNO}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾍ.登録番号】</div>
          <div class="gaiyo-element left-45">{{iken.ikensyA_TRK_NO}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾄ.意見を聴いた設計図書】</div>
          <div class="gaiyo-element left-60">{{iken.bK_NAME}}</div>
          <div v-for="(n,index) in wordwrap(iken.bK_NAME,34)" :key="`iken-bkname-${index}`">
            <br v-show="index>0"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    ikens: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: () => 0
    },
    endIndex: {
      type: Number,
      default: () => 99
    }
  },
  mounted() {
    //console.log(this.endIndex);
  },
  computed: {
  },
  methods: {
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/common/common.css";
</style>